import gql from "graphql-tag";

export const AssistantsSearch = gql`
  query AssistantsSearch($brokerId: String!, $search: String!) {
    AssistantsSearch(brokerId: $brokerId, search: $search) {
      id
      full_name
      email
    }
  }
`;



// WEBPACK FOOTER //
// ./src/queries/assistant/queries.js